import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import CountdownTimer from './CountdownTimer.js'; // Ensure path is correct
import './TearOffCalendar.css';

const TearOffCalendar = ({ targetDate, title, activeEvent, onEventSelect }) => {
    const stackRef = useRef(null);
    const lastGeneratedDateRef = useRef(new Date());
    const [pages, setPages] = useState([]);



    useEffect(() => {
        // Оновлюємо z-index та позиціювання кожного разу, коли змінюється стек сторінок
        // Це критично, щоб перша сторінка (сьогодні/вчора) перекривала майбутні
        if (stackRef.current) {
            const wrappers = stackRef.current.querySelectorAll('.page-wrapper');
            wrappers.forEach((el, i) => {
                el.style.zIndex = 100 - i;
                // Легкий зсув для ефекту стосу
                gsap.set(el, {
                    z: -i * 2,
                    rotationX: -i * 0.5
                });
            });
        }
    }, [pages]);

    const getSavedDate = () => {
        // Завжди починаємо з "Вчора", щоб користувач міг відірвати листок і побачити "Сьогодні"
        // Це вимога: "При запуску має бути попередня дата до поточної"
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return yesterday;
    };

    const months = [
        "Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень",
        "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"
    ];

    const weekdays = [
        "Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"
    ];

    const decemberPoems = [
        "Зима прийшла, летить сніжок,\nДо нас спішить вже Новий рік.\nГотуй ялинку та мішок,\nДля подарунків та утіх!", // 1
        "Грудень землю обіймає,\nБілим снігом засипає.\nМрії наші оживають,\nСвята радість сповіщають.", // 2
        "Сніжинки падають з небес,\nУ світі стільки є чудес!\nЛиш вір у казку, вір у мрію,\nВона здійснить твою надію.", // 3
        "Морозець малює квіти,\nНа вікні для нас з тобою.\nБудем свята ми радіти,\nЗ чистим серцем і любов'ю.", // 4
        "Вже скоро Миколай прийде,\nСлухняним діткам принесе.\nЦукерки, іграшки, пакунки,\nІ найщиріші поцілунки!", // 5
        "Ой, хто, хто Миколая любить,\nТому святий допомагає.\nХай в кожну хату завітає,\nІ щастям всіх благословляє.", // 6 (Миколая)
        "Ялинка вогниками сяє,\nКолядка радісно лунає.\nВеселий сміх, дитячі мрії,\nЗбуваються усі надії.", // 7
        "Сніг кружляє, сніг летить,\nЗупинись чудова мить!\nВсе навколо, мов у казці,\nВ божій та батьківській ласці.", // 8
        "Завірюха завиває,\nА у нас тепло і світло.\nКожен серцем відчуває,\nЯк добро у нім розквітло.", // 9
        "Вже чути дзвоники святкові,\nВсі люди вбралися в обнові.\nЧекають дива і тепла,\nЩоб доля радісна була.", // 10
        "Біла казка за вікном,\nСпить природа тихим сном.\nТільки ми не будем спати,\nБдем свято зустрічати!", // 11
        "Прикрасим іграшками дім,\nЩоб затишно було у нім.\nГірлянди, кульки і вогні,\nДарують радість у ці дні.", // 12
        "Мандарини пахнуть святом,\nПодарунків є багато.\nСміх лунає там і тут,\nСвята в гості до нас йдуть.", // 13
        "Зірка в небі засіяла,\nШлях до щастя показала.\nХай веде вона нас всіх,\nЧерез гори і через сніг.", // 14
        "Сніговик стоїть у дворі,\nПосміхається дітворі.\nНіс-морквина, очі-вуглинки,\nЛовить ротом він сніжинки.", // 15
        "Миколай уже пішов,\nАле свято не скінчилось.\nЩоб кожен тут любов знайшов,\nІ серце радістю налилось.", // 16
        "Вже скоро Різдво завітає,\nКолядка над світом лунає.\nРадійте, люди, Христос родився,\nСлавіте його, він нам явився!", // 17
        "Іній на гілках сріблиться,\nСвято знову нам насниться.\nПро добро і про любов,\nЩо хвилює нашу кров.", // 18
        "Подаруй тепло долонь,\nЗапали в душі вогонь.\nХай різдвяна ніч свята,\nНам дарує літа.", // 19
        "Світло, радість, благодать,\nХочу всім я побажать.\nМиру, щастя і добра,\nЗичить діткам дітвора.", // 20
        "Зимовий вечір, сніг рипить,\nЗоря різдвяна вже горить.\nЗбирайтесь всі за стіл святковий,\nВеселий, щедрий і здоровий.", // 21
        "Янголи сурмлять з небес,\nЩо Христос-Дитя воскрес!\nРадість людям всім несуть,\nВ добру і щасливу путь.", // 22
        "Хай кутя буде смачна,\nА родина — голосна.\nХай колядка в дім летить,\nЩастя в хаті хай дзвенить!", // 23
        "Святий вечір на поріг,\nБілий сніг на землю ліг.\nВ хаті вогник вже горить,\nВся родина гомонить.", // 24
        "Христос Рождається! Славімо!\nРадісну вість всім говорімо.\nНехай любов панує в світі,\nУ кожнім серці, в кожнім діті.", // 25 (Різдво)
        "Вже минає старий рік,\nНовий вже ступа на поріг.\nВсе, що було — не забудь,\nА в майбутнє — з вірой будь.", // 26
        "Сніжок пухнастий, білий-білий,\nВкриває землю, наче килим.\nМинає день, минає ніч,\nЖеніть ви смуток з хати пріч.", // 27
        "Скоро, скоро Новий рік,\nПереступить наш поріг.\nЗ новим щастям, з новим днем,\nМи в майбутнє всі ідем.", // 28
        "Ялинка сяє, мерехтить,\nЧудова і казкова мить.\nЗагадаємо бажання,\nПриймемо ми привітання.", // 29
        "Цукерки, подарунки, сміх,\nХай вистачить всього на всіх.\nХай буде щедрим Новий рік,\nНа довгий і щасливий вік.", // 30
        "Дванадцять б’є, годинник, час!\nЗ Новим роком, друзі, вас!\nХай збуваються дива,\nЛине слава світова!"  // 31
    ];

    const wishes = [
        "Нехай цей день принесе удачу!",
        "Усміхнись, сьогодні твій день!",
        "Час для нових звершень!",
        "Зроби крок до своєї мрії!",
        "Сьогодні станеться щось чудове!",
        "Наповни день позитивом!",
        "Ти здатен на все!",
        "Не бійся ризикувати!",
        "Щастя в дрібницях!",
        "Створи свій ідеальний момент!",
        "Вір у себе!",
        "Сьогодні – найкращий день!",
        "Люби, твори, надихай!",
        "Залиш сумніви позаду!",
        "Сяй яскравіше зірок!",
        "Твоя енергія змінює світ!",
        "Подаруй комусь усмішку!",
        "Час здійснити бажання!",
        "Будь собою!",
        "Насолоджуйся кожною миттю!"
    ];



    const festiveStickers = ["🎄", "🎅", "🎁", "❄️", "⛄", "🔔", "🕯️", "🍪", "🦌", "🧣", "🧦", "🌟"];

    const getRandomWish = () => {
        return wishes[Math.floor(Math.random() * wishes.length)];
    };

    const getPageContent = (date) => {
        const month = date.getMonth();
        const day = date.getDate();

        if (month === 11) { // Грудень
            // Вірш для конкретного дня (індекс дня - 1, бо масив з 0)
            // Повертаємо вірш, якщо він є, або дефолтний, якщо днів більше 31 :)
            return decemberPoems[day - 1] || "Зимова казка за вікном...";
        }
        return getRandomWish();
    };

    const getRandomStickers = (count = 3) => {
        const stickers = [];
        for (let i = 0; i < count; i++) {
            stickers.push(festiveStickers[Math.floor(Math.random() * festiveStickers.length)]);
        }
        return stickers;
    };

    useEffect(() => {
        initCalendar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initCalendar = () => {
        const startDate = getSavedDate();
        const initialPages = [];
        for (let i = 0; i < 6; i++) {
            const d = new Date(startDate);
            d.setDate(startDate.getDate() + i);

            initialPages.push({
                id: `page-${Date.now()}-${i}`,
                date: d,
                visualIndex: i,
                content: getPageContent(d),
                stickers: d.getMonth() === 11 ? getRandomStickers(5) : []
            });

            if (i === 5) lastGeneratedDateRef.current = new Date(d);
        }
        setPages(initialPages);
    };

    // ... (useEffect for gsap stack animation remains same)

    const sideTear = (pageId) => {
        // ... (sideTear implementation remains same)
        // Keeping references strictly to avoid implementation issues, just need to ensure getPageContent is used later
        const wrapper = document.getElementById(pageId);
        if (!wrapper || wrapper.dataset.active === "true") return;

        wrapper.dataset.active = "true";
        const body = wrapper.querySelector('.page-body');
        const shadow = wrapper.querySelector('.page-shadow');
        const torn = wrapper.querySelector('.torn-top');

        const pageToTear = pages.find(p => p.id === pageId);

        torn.style.display = 'block';

        const tl = gsap.timeline({
            onComplete: () => {
                // Зберігаємо дату наступної сторінки
                const nextDate = new Date(pageToTear.date);
                nextDate.setDate(nextDate.getDate() + 1);
                localStorage.setItem('calendar_current_date', nextDate.toISOString());

                addNextPageAndRemoveOld(pageId);
            }
        });

        tl.to(body, {
            duration: 0.3,
            rotationY: -15,
            rotationZ: 5,
            x: 10,
            skewY: -2,
            ease: "sine.inOut"
        })
            .to(shadow, { duration: 0.3, opacity: 1 }, 0)
            .to(body, {
                duration: 0.1,
                x: 40,
                y: 10,
                rotationZ: 15,
                ease: "power2.in"
            })
            .to(body, {
                duration: 0.7,
                x: 1000,
                y: 400,
                rotationZ: 45,
                rotationY: -90,
                opacity: 0,
                ease: "power3.in"
            });
    };

    const addNextPageAndRemoveOld = (oldPageId) => {
        // Оновлюємо дату
        lastGeneratedDateRef.current.setDate(lastGeneratedDateRef.current.getDate() + 1);
        const d = new Date(lastGeneratedDateRef.current);

        setPages(prevPages => {
            // Видаляємо стару сторінку
            const filteredPages = prevPages.filter(p => p.id !== oldPageId);

            // Створюємо нову сторінку
            const newPage = {
                id: `page-${Date.now()}`,
                date: d,
                visualIndex: 6,
                content: getPageContent(d),
                stickers: d.getMonth() === 11 ? getRandomStickers(5) : []
            };

            // Додаємо нову в кінець
            const updatedPages = [...filteredPages, newPage];

            setTimeout(() => {
                const remainingWrappers = stackRef.current?.querySelectorAll('.page-wrapper');
                remainingWrappers?.forEach((el, i) => {
                    gsap.to(el, {
                        duration: 0.4,
                        z: -i * 2,
                        rotationX: -i * 0.5,
                        overwrite: true
                    });
                    el.style.zIndex = 100 - i;
                });
            }, 0);

            return updatedPages;
        });
    };



    // ... (rest of render)

    return (
        <div className="tear-off-calendar-container">
            <div className="christmas-timer">
                <CountdownTimer targetDate={targetDate} title={title} />
                <div className="timer-controls">
                    <span
                        className={`control-icon ${activeEvent === 'christmas' ? 'active' : ''}`}
                        onClick={() => onEventSelect('christmas')}
                        title="До Різдва"
                    >
                        🎄
                    </span>
                    <span
                        className={`control-icon ${activeEvent === 'birthday' ? 'active' : ''}`}
                        onClick={() => onEventSelect('birthday')}
                        title="До Дня Народження"
                    >
                        🎂
                    </span>
                </div>
            </div>
            <div className="calendar-wrapper">
                <div className="mount">
                    <div className="bolt"></div>
                    <div className="bolt"></div>
                    <div className="bolt"></div>
                    <div className="bolt"></div>
                </div>
                <div className="pages-stack" ref={stackRef}>
                    {pages.map((page) => {
                        const isDecember = page.date.getMonth() === 11;
                        const isAdvent = isDecember && page.date.getDate() <= 25;
                        return (
                            <div
                                key={page.id}
                                id={page.id}
                                className="page-wrapper"
                            >
                                <div className="page-stub"></div>
                                <div
                                    className={`page-body ${isAdvent ? 'is-festive' : ''}`}
                                    onClick={() => sideTear(page.id)}
                                >
                                    <div className="torn-top"></div>
                                    <div className="page-shadow"></div>

                                    {/* Stickers Layer */}
                                    {isDecember && (
                                        <div className="stickers-layer">
                                            {page.stickers.map((sticker, idx) => (
                                                <div key={idx} className={`sticker sticker-${idx}`}>
                                                    {sticker}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <div className="page-content">
                                        <div className="month">
                                            {months[page.date.getMonth()]} {page.date.getFullYear()}
                                        </div>
                                        <div className="day">{page.date.getDate()}</div>
                                        <div className="weekday">{weekdays[page.date.getDay()]}</div>

                                        {/* Відображаємо вірш або побажання з урахуванням нових рядків */}
                                        <div className={`wish ${isDecember ? 'poem' : ''}`}>
                                            {page.content.split('\n').map((line, i) => (
                                                <React.Fragment key={i}>
                                                    {line}<br />
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>

                                    {isDecember && (
                                        <div className="decorations">
                                            <div className="snowflake">❄</div>
                                            <div className="snowflake">❄</div>
                                            <div className="snowflake">❄</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TearOffCalendar;
